
import React from "react";
import { Briefcase, ShoppingBag, Phone, Wrench, Sparkles, Star, BarChart, Users, Shield, Clock, Globe, Settings } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import SlideLayout from "../components/SlideLayout";

const ProductsDetailSlide = () => {
  return (
    <SlideLayout>
      <div className="space-y-8">
        <Tabs defaultValue="atelier" className="w-full">
          <TabsList className="grid grid-cols-4 mb-8">
            <TabsTrigger value="atelier" className="bg-white data-[state=active]:bg-indigo-100 data-[state=active]:text-indigo-700">
              <div className="flex items-center">
                <Briefcase className="mr-2 h-4 w-4" />
                <span>Atelier</span>
              </div>
            </TabsTrigger>
            <TabsTrigger value="pronto" className="bg-white data-[state=active]:bg-pink-100 data-[state=active]:text-pink-700">
              <div className="flex items-center">
                <ShoppingBag className="mr-2 h-4 w-4" />
                <span>Pronto</span>
              </div>
            </TabsTrigger>
            <TabsTrigger value="concierge" className="bg-white data-[state=active]:bg-cyan-100 data-[state=active]:text-cyan-700">
              <div className="flex items-center">
                <Phone className="mr-2 h-4 w-4" />
                <span>Concierge</span>
              </div>
            </TabsTrigger>
            <TabsTrigger value="custom" className="bg-white data-[state=active]:bg-amber-100 data-[state=active]:text-amber-700">
              <div className="flex items-center">
                <Wrench className="mr-2 h-4 w-4" />
                <span>Custom</span>
              </div>
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="atelier" className="focus-visible:outline-none focus-visible:ring-0">
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-indigo-600 mb-4 font-poppins">Enterprise Custom AI Solution</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="bg-white backdrop-blur-sm border border-indigo-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                        <Sparkles className="h-5 w-5 text-indigo-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-indigo-700 font-poppins">Personalization</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Custom AI Voice Creation</li>
                          <li>• Brand Voice Training</li>
                          <li>• Personalized Shopping Experience</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white backdrop-blur-sm border border-indigo-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                        <Users className="h-5 w-5 text-indigo-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-indigo-700 font-poppins">Customer Engagement</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Multi-channel Support</li>
                          <li>• Voice AI in 30+ languages</li>
                          <li>• Advanced Conversational AI</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="bg-white backdrop-blur-sm border border-indigo-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                        <BarChart className="h-5 w-5 text-indigo-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-indigo-700 font-poppins">Analytics & Intelligence</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Advanced Analytics Dashboard</li>
                          <li>• Real-time Insights</li>
                          <li>• Customer Behavior Analysis</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white backdrop-blur-sm border border-indigo-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-indigo-100 p-2 rounded-lg mr-3">
                        <Settings className="h-5 w-5 text-indigo-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-indigo-700 font-poppins">Operations</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Inventory Intelligence</li>
                          <li>• Dynamic Pricing</li>
                          <li>• Order Management</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabsContent>
          
          <TabsContent value="pronto" className="focus-visible:outline-none focus-visible:ring-0">
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-pink-600 mb-4 font-poppins">Quick-deploy Shopify Solution</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-white backdrop-blur-sm border border-pink-300 p-6 rounded-lg shadow-md">
                  <div className="flex items-start">
                    <div className="bg-pink-100 p-2 rounded-lg mr-3">
                      <Star className="h-5 w-5 text-pink-600" />
                    </div>
                    <div>
                      <h4 className="text-xl font-medium mb-3 text-pink-700 font-poppins">Key Features</h4>
                      <ul className="space-y-3 text-gray-700 font-nunito">
                        <li>• AI Chatbot & Personal Shopper</li>
                        <li>• Product Knowledge & Integration</li>
                        <li>• Customization & Appearance</li>
                        <li>• 24/7 Global Support</li>
                        <li>• Analytics & Insights</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="bg-white backdrop-blur-sm border border-pink-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-pink-100 p-2 rounded-lg mr-3">
                        <BarChart className="h-5 w-5 text-pink-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-pink-700 font-poppins">Simple Pricing</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Basic: Free (10 AI conversations/month)</li>
                          <li>• Starter: $25/month (100 conversations)</li>
                          <li>• Pro: $99/month (1,000 conversations)</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white backdrop-blur-sm border border-pink-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-pink-100 p-2 rounded-lg mr-3">
                        <Clock className="h-5 w-5 text-pink-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-pink-700 font-poppins">Implementation</h4>
                        <p className="text-gray-700 font-nunito">Install in minutes with zero setup required - ideal for small to medium-sized e-commerce businesses</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabsContent>
          
          <TabsContent value="concierge" className="focus-visible:outline-none focus-visible:ring-0">
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-cyan-600 mb-4 font-poppins">AI Phone Receptionist</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="bg-white backdrop-blur-sm border border-cyan-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-cyan-100 p-2 rounded-lg mr-3">
                        <Globe className="h-5 w-5 text-cyan-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-cyan-700 font-poppins">Smart Call Management</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Intelligent call routing</li>
                          <li>• Priority call handling</li>
                          <li>• Call recording and transcription</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white backdrop-blur-sm border border-cyan-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-cyan-100 p-2 rounded-lg mr-3">
                        <Clock className="h-5 w-5 text-cyan-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-cyan-700 font-poppins">Appointment & Scheduling</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Calendar integration</li>
                          <li>• Automated reminders</li>
                          <li>• Complex scheduling capabilities</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="bg-white backdrop-blur-sm border border-cyan-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-cyan-100 p-2 rounded-lg mr-3">
                        <Globe className="h-5 w-5 text-cyan-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-cyan-700 font-poppins">Multilingual & Personalized</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Support for 30+ languages</li>
                          <li>• Caller identification and recall</li>
                          <li>• Custom voice matching your brand</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white backdrop-blur-sm border border-cyan-300 p-6 rounded-lg shadow-md">
                    <div className="flex items-start">
                      <div className="bg-cyan-100 p-2 rounded-lg mr-3">
                        <BarChart className="h-5 w-5 text-cyan-600" />
                      </div>
                      <div>
                        <h4 className="text-xl font-medium mb-2 text-cyan-700 font-poppins">Business Impact</h4>
                        <ul className="space-y-2 text-gray-700 font-nunito">
                          <li>• Reduction in missed calls</li>
                          <li>• Increase in appointment bookings</li>
                          <li>• Significant cost savings vs 24/7 staffing</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabsContent>
          
          <TabsContent value="custom" className="focus-visible:outline-none focus-visible:ring-0">
            <div className="space-y-8">
              <h3 className="text-3xl font-bold text-amber-600 mb-4 font-poppins">Bespoke AI Solutions</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-white backdrop-blur-sm border border-amber-300 p-6 rounded-lg shadow-md">
                  <h4 className="text-xl font-medium mb-3 text-amber-700 font-poppins">Applications</h4>
                  <ul className="space-y-3 text-gray-700 font-nunito">
                    <li>• Industry-specific AI solutions</li>
                    <li>• Custom voice and personality development</li>
                    <li>• Integration with proprietary systems</li>
                    <li>• Specialized use cases not covered by other products</li>
                  </ul>
                </div>
                <div className="bg-white backdrop-blur-sm border border-amber-300 p-6 rounded-lg shadow-md">
                  <h4 className="text-xl font-medium mb-3 text-amber-700 font-poppins">Process</h4>
                  <ul className="space-y-3 text-gray-700 font-nunito">
                    <li>• Discovery phase</li>
                    <li>• Custom design and development based on your brand and marketing strategy</li>
                    <li>• Training on product information and company history and values</li>
                    <li>• Ongoing support and enhancement</li>
                  </ul>
                </div>
              </div>
              <div className="bg-white backdrop-blur-sm border border-amber-300 p-6 rounded-lg shadow-md">
                <h4 className="text-xl font-medium mb-3 text-amber-700 font-poppins">When to Consider Custom</h4>
                <p className="text-gray-700 font-nunito">
                  Ideal for businesses with unique requirements, specialized workflows, or integration needs that go beyond our standard solutions.
                </p>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </SlideLayout>
  );
};

export default ProductsDetailSlide;
